import {
    animate,
    animateChild,
    query,
    state,
    style,
    transition,
    trigger,
} from "@angular/animations";
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
} from "@angular/core";

import { WINDOW } from "@hermes/core-app-core";
import { AnalyticsService } from "@hermes/hermes-web-fragments-analytics";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";

import { RedrawDirective } from "../../directives/redraw/redraw.directive";
import { SearchEvent } from "../../events/search.event";
import { Suggestion } from "../../model/suggestions";
import { StrongPipe } from "../../pipes/strong.pipe";
import { SuggestionItemPipe } from "../../pipes/suggestion-item.pipe";

@Component({
    selector: "h-header-search-suggestions",
    imports: [
        RedrawDirective,
        SrOnlyNoSnippetDirective,
        SuggestionItemPipe,
        StrongPipe,
    ],
    templateUrl: "./header-search-suggestions.component.html",
    styleUrls: ["./header-search-suggestions.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger("animateContainer", [
            state("open", style({ opacity: 1, height: "*" })),
            state("closed", style({ opacity: 0, height: 0 })),
            transition("closed => open", [
                animate("100ms ease-out"),
                query("@animateSuggestions", animateChild()),
            ]),
            transition("open => closed", [animate("100ms ease-out")]),
        ]),
        trigger("animateSuggestions", [
            state("open", style({ opacity: 1, transform: "none" })),
            state("closed", style({ opacity: 0, transform: "translateX(5%)" })),
            transition("closed => open", [animate("300ms ease-out")]),
        ]),
    ],
})
export class HeaderSearchSuggestionsComponent {
    private window = inject<Window>(WINDOW);
    private analyticsService = inject(AnalyticsService);

    @Input()
    public suggestions?: Suggestion[];

    @Input()
    public searchTerm!: string;

    @Input()
    public selected: number | undefined;

    public getSuggestionsState(): "open" | "closed" {
        return this.suggestions ? "open" : "closed";
    }

    public sendSearchEvent(
        suggestionLabel: string,
        position: number,
        isProductPage: boolean,
    ): void {
        this.analyticsService.sendData(
            new SearchEvent({
                eventaction: `Search suggest list : product ${isProductPage ? "page" : "grid"}`,
                eventlabel: `${this.searchTerm} : ${suggestionLabel}`,
                eventvalue: position,
            }),
        );
    }

    public redirect(suggestion: Suggestion, position: number): void {
        this.sendSearchEvent(suggestion.label, position, !!suggestion.sku);
        this.window.location.href = suggestion.url;
    }
}
